import { useContext, useState } from 'react'

import axios from 'axios'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import CustomButton from './customButton';

import './login.css';
import { UserContext } from '../context/user-context'

export default function LoginForm() {
  const [loading, setLoading] = useState(false);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { userToken, setUser, setUserToken } = useContext(UserContext);

  const togglePassVisibility = () => {
    setShowPassword(!showPassword);
  };

  const loginAs = () => {
    setLoading(true);
    // console.log(process.env);
    axios.post(process.env.REACT_APP_API_BASE_URL + '/wp-json/app/v1/login-as', {}, {
      headers: {
        'Authorization': 'Basic ' + btoa(login + ":" + password),
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      if (res.data.success) {
        setUser(res.data.user)
        setUserToken(password)
        return;
      }
      alert(res.data.error);
      console.log(res);
    }).catch(err => {
      alert('Error!! Please check your internet connection');
    }).finally(() => {
      setLoading(false);
    });
  }

  const processLogin = (event) => {
    event.preventDefault();
    if (!login || !password) {
      alert('Please enter both Login & Password');
      return;
    }
    if (process.env.REACT_APP_ENABLE_LOGIN_AS) {
      loginAs()
      return
    }
    setLoading(true);
    // console.log(process.env);
    // axios.post(process.env.REACT_APP_API_BASE_URL + '/wp-json/app/v1/login', {
    axios.post(process.env.REACT_APP_API_BASE_URL + '/wp-json/gnetwork/v1/event-hosts/login', {
      'login': login,
      'password': password
    }).then(res => {
      if (res.data.success) {
        setUser(res.data.user)
        setUserToken(res.data.token)
        return;
      }
      alert(res.data.error);
      console.log(res);
    }).catch(err => {
      alert('Error!! Please check your internet connection');
    }).finally(() => {
      setLoading(false);
    });
  }

  return (
    <Row className="justify-content-center w-100">
      <Col lg="6">
        <p className="text-center text-danger">This application is currently restricted to specific event hosts.</p>
        <p className="text-center text-warning">We recommend using a desktop device, it is not yet mobile optimized.</p>
        <Form className="login-form" onSubmit={processLogin}>
          <Form.Group className="mb-3" controlId="formBasicLogin">
            <Form.Label className="text-white">Username or Email address</Form.Label>
            <Form.Control type="text" placeholder="Enter username or email address" defaultValue={login} onKeyUp={(event) => {
              setLogin(event.target.value)
            }}/>
            {/*<Form.Text className="text-gray">We'll never share your email with anyone else.</Form.Text>*/}
          </Form.Group>
          <Form.Group className="p-relative mb-3" controlId="formBasicPassword">
            <Form.Label className="text-white">Password</Form.Label>
            <Form.Control 
              type={showPassword ? 'text' : 'password'} 
              placeholder="Password" 
              defaultValue={password} 
              onKeyUp={(event)=>{
                setPassword(event.target.value)
              }}
            />
            <span
              className="position-absolute end-0 translate-middle-y p-2"
              onClick={togglePassVisibility}
              style={{ cursor: "pointer", top: '3rem', }}
            >
              <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`} aria-hidden="true"></i>
            </span>
          </Form.Group>
          <CustomButton type="submit" color="green" text={!loading ? 'Login' : 'Logging...'} className="login-button"/>
          {/*
            <Button variant="primary" type="submit" className="w-100" disabled={loading}>
              {!loading ? 'Login' : 'Processing...'}
            </Button>
          */}
          <div className="text-center text-silver mt-3">
            <span>Don't have an account? <a href="https://gnetworkclub.com/join/" target="_blank" className="d-inline-block text-white">Sign Up</a></span>
            <a href="https://gnetworkclub.com/account/lost-password/" target="_blank" className="d-block text-white mt-3">Forgot password?</a>
          </div>
        </Form>
      </Col>
    </Row>
  );
}
